<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <!-- <div > -->
                <div class="hidden">
                <a-form-item label="ID主键" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入ID主键" />
                </a-form-item><a-form-item label="项目ID" name="projectId">
                    <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                </a-form-item><a-form-item label="分类ID" name="classification">
                    <a-input v-model:value="form.classification" placeholder="请输入分类ID" />
                </a-form-item>
            </div>

            <a-row :gutter="20">

                <a-col :span="24">
                    <a-form-item label="研究人员信息类型（重点研发计划，科技成果转化引导专项）" name="researchersType">
                        <DictSelect v-model:value="form.researchersType" :dict-name="'researchersType'" style="margin: -5px 0"
                          placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="姓名" name="name">
                        <a-input v-model:value="form.name" placeholder="请输入姓名" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="性别" name="sex">
                        <a-radio-group v-model:value="form.sex">
                            <a-radio :value="0">男</a-radio>
                            <a-radio :value="1">女</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="出生日期" name="birth">
                        <date-picker v-model:value="form.birth" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="学位（最高学历学位）" name="academicDegree">
                        <DictSelect v-model:value="form.academicDegree" :dict-name="'education_background'" style="margin: -5px 0"
                        placeholder="请选择" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="职称(职务)" name="duties">
                        <a-input v-model:value="form.duties" placeholder="请输入职称(职务)" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="专业" name="speciality">
                        <a-input v-model:value="form.speciality" placeholder="请输入专业" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="承担任务" name="undertakeTasks">
                        <a-input v-model:value="form.undertakeTasks" placeholder="请输入承担任务" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="单位" name="workUnit">
                        <a-input v-model:value="form.workUnit" placeholder="请输入单位" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="手机号" name="phone">
                        <a-input v-model:value="form.phone" placeholder="请输入手机号" />
                    </a-form-item>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import DictSelect from "@/components/other/DictSelect";
// import store from '@/store';
import {projectResearchers} from "@/api/TechnologieprojekteApply";

export default {
    name: "研究人员信息",
    components: {DictSelect},

    mixins: [formMixin],
    data() {
        return {
            form: {
                    id: null,
                    projectId: null,
                    classification: null,
                    researchersType: null,
                    name: null,
                    sex: null,
                    birth: null,
                    academicDegree: null,
                    duties: null,
                    speciality: null,
                    undertakeTasks: null,
                    workUnit: null,
                    phone: null,
                },
                rules: {
                    id: [],
                    projectId: [
                        dataCheck.required({}),
                    ],
                    classification: [
                        dataCheck.required({}),
                    ],
                    researchersType: [
                        dataCheck.required({}),
                    ],
                    name: [
                        dataCheck.required({}),
                    ],
                    sex: [
                        dataCheck.required({type:"number"}),
                    ],
                    birth: [
                        dataCheck.required({}),
                    ],
                    academicDegree: [
                        dataCheck.required({}),
                    ],
                    duties: [
                        dataCheck.required({}),
                    ],
                    speciality: [
                        dataCheck.required({}),
                    ],
                    undertakeTasks: [
                        dataCheck.required({}),
                    ],
                    workUnit: [
                        dataCheck.required({}),
                    ],
                    phone: [
                        dataCheck.required({}),dataCheck.mobile_phone
                    ],
                },

        }
    },
    
    computed: {
            submitUrl() {
                return projectResearchers.saveOrUpdate
            },
        },
    mounted() {
    },
    methods: {
        postForm(e,m){
            setTimeout(() => {
                this.form.projectId = e,
                this.form.classification = m
            }, 50);
        }
    },
}
</script>
<style scoped lang="less">
</style>
